export default (str)=>{
  if(str){
    // let reg=/<\/?.+?\/?>/g;
    // let rep=str.replace(reg,'')
    let content = str.replace(/<\/?[^>]*>/g,"").replace(/&[a-zA-Z]{1,10};/g, '');//去除标签
    // content = content.replace(/\\&[a-zA-Z]{1,10};/,"");//去除行尾空格
    // let content = str.replace(/<(?!img).*?>/g, "");
    // let content = str.replace(/<(?!\/?br\/?.+?>)[^<>]*>/g,"");//去除标签
    return content
  }else{
    return ''
  }
}


// WEBPACK FOOTER //
// ./src/filter/rephtml.js